export default import.meta.ROLLUP_FILE_URL_lGeou1MNfbIsfOUq0buSkA